import styled from 'styled-components';

export const InputExample = styled.span`
  margin: 10px;
`;

export const InputLabel = styled.div`
  color: #6B778C;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3333333333333333;
  padding: 20px 0px 4px 0px;
`;
